import { getLangKey } from '@translate';
import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import Typography from 'src/components/Typography';
import { RootStoreType } from 'src/types/store';
import Alert, { AlertProps } from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { ApplicationStatusMessageType } from 'src/types/applicationStatusMessage';
import moment from 'moment';
import { styled } from '@mui/system';
import { colors } from 'src/themes/default';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const StyledAlert = styled(Alert)<AlertProps>(({ theme, severity }) => ({
    backgroundColor: colors.background_W,
    cursor: 'pointer',
    margin: '0px',
    marginBottom: '10px',
    borderWidth: '3px',
    position: 'relative',

    '& .MuiTypography-h3': {
        [theme.breakpoints.up('sm')]: {
            marginRight: '120px'
        }
    },

    '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit': {
        fill: severity === 'warning' ? '#ff9800' : severity === 'error' ? '#ef5350' : '#03a9f4'
    },

    '& .MuiTypography-body2': {
        [theme.breakpoints.up('sm')]: {
            position: 'absolute',
            right: '40px',
            top: '17px'
        }
    }
}));

const CollapseIcon = styled('div')({
    position: 'absolute',
    right: '15px',
    top: '13px'
});

const ApplicationStatusMessagesContainer: FC<{ mobile?: boolean }> = () => {
    const data = useSelector((state: RootStoreType) => state.applicationStatusMessagesList.dataActive);
    const [open, setOpen] = useState<{ [key: string]: boolean }>({});
    const langkey = getLangKey();

    const toggleOpen = (message: ApplicationStatusMessageType) => {
        const newOpen = { ...open };
        if (!message.ID) {
            return;
        }
        if (open[message.ID]) {
            delete newOpen[message.ID];
        } else {
            newOpen[message.ID] = true;
        }
        setOpen(newOpen);
    };

    if (!data?.length) {
        return null;
    }

    return (
        <div>
            {data
                .filter((message): boolean => message.LANG === langkey && (message.NOTIFICATION_TYPE === 'banner' || message.NOTIFICATION_TYPE === 'both'))
                .map((message) => {
                    const collapsed = open[message.ID || 0];
                    return (
                        <StyledAlert
                            key={message.ID}
                            variant="outlined"
                            severity={message.TYPE}
                            onClick={() => {
                                toggleOpen(message);
                            }}
                        >
                            <Typography variant="h3">
                                <div dangerouslySetInnerHTML={{ __html: message.TITLE || '' }} />
                            </Typography>
                            <Typography variant="body2">{moment(message.CREATED_AT).format('lll')}</Typography>
                            <CollapseIcon>{collapsed ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</CollapseIcon>
                            <Collapse in={collapsed} timeout="auto" unmountOnExit>
                                <div
                                    dangerouslySetInnerHTML={{ __html: message.TEXT || '' }}
                                    style={{ marginTop: '0.35em' }}
                                />
                            </Collapse>
                        </StyledAlert>
                    );
                })}
        </div>
    );
};

export default ApplicationStatusMessagesContainer;
